import React from "react";

type ColorSwatchBoxProps = {
  hex: string;
  label: string;
};

const normalizeHex = (hex: string): string => {
  const cleaned = hex.replace("#", "").trim();
  if (!cleaned) {
    return "#ffffff";
  }
  return `#${cleaned}`;
};

const getContrastColor = (hex: string): string => {
  const cleaned = hex.replace("#", "");
  const value = parseInt(cleaned, 16);
  if (Number.isNaN(value)) {
    return "#212121";
  }

  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#212121" : "#ffffff";
};

const ColorSwatchBox: React.FC<ColorSwatchBoxProps> = ({ hex, label }) => {
  const normalizedHex = normalizeHex(hex);
  const textColor = getContrastColor(normalizedHex);

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-medium uppercase tracking-wide text-tertiary">
        {label}
      </span>
      <div
        className="h-24 rounded-xl border border-light flex items-center justify-center shadow-sm"
        style={{ backgroundColor: normalizedHex }}
      >
        <span
          className="text-sm font-semibold px-3 py-1 rounded-md bg-white/20 backdrop-blur-sm"
          style={{ color: textColor }}
        >
          {normalizedHex.toUpperCase()}
        </span>
      </div>
    </div>
  );
};

export default ColorSwatchBox;
